import React, {useEffect, useState} from 'react'
import { inputTypes } from '../../../libs/react-mpk/config/constant'
import { FormWrapper } from '../../../libs/react-mpk/wrapper'
import t from 'counterpart'
import { inject, observer } from 'mobx-react'
import service from './TipePenghasilanLamp1771ivs.service'
import kelompokPenghasilanService from './../kelompokPenghasilan/KelompokPenghasilan.service'

const TipePenghasilanLamp1771ivsForm = ({envStore, match, history}) => {
  const { inputTypes, definition } = FormWrapper
  const [data, setData] = useState({loading: true, content: {}})
  const [kelompokPenghasilans, setKelompokPenghasilans] = useState([])

  const getKelompokPenghasilan = async ()=> {
    var kelompokPenghasilanOP = []
    const kelompokPenghasilan = await kelompokPenghasilanService.get()
    kelompokPenghasilan.data.map((d)=> { kelompokPenghasilanOP.push({ label: d.nama, value: d.id }) })
    setKelompokPenghasilans(kelompokPenghasilanOP)
  }

  // initial data
  useEffect(() => {
    async function initData() {
      if(match.params.id == 'baru') {
        setData({loading: false, content: {}})
        return true
      }
      const res = await service.getOne(match.params.id)
      setData({loading: false, content:res.data})
    }
    getKelompokPenghasilan()
    initData()
  }, ['match.params.id'])

  return (
    <FormWrapper
      loading={data.loading}
      actions={[
        {
          label: 'Reload',
          iconClassName: 'mdi mdi-reload'
        }
      ]}
      backTo={`/onpremise/tipePenghasilanLamp1771ivs`}
      baseId="mod-form-sample"
      title={t.translate('modules.tipePenghasilanLamp1771ivs.formTitle')}
      // hintMessage={t.translate('modules.form.hint.message')}
      hintShowIcon={false}
      defaultData={data.content}
      definitions={[
        // =====
        {
          inputType: inputTypes.INPUT,
          label: 'Nomor',
          key: 'nomor',
          type: 'text',
          required: true,
        },{
          inputType: inputTypes.INPUT,
          label: 'Nama',
          key: 'nama',
          type: 'text',
          required: true,
        },{
          inputType: inputTypes.INPUT,
          label: 'Keterangan',
          key: 'keterangan',
          type: 'text'
        },{
          inputType: inputTypes.SELECT,
          label: 'Kelompok Penghasilan',
          key: 'kelompokPenghasilanId',
          type: 'text',
          required: true,
          options: kelompokPenghasilans
        },
        // -----
      ]}
      onSubmit={async (data, callback) => {
        var res = {}
        try {
          if(match.params.id == 'baru') {
            res = await service.post(data)
          } else {
            res = await service.put(data)
          } 
          callback(t.translate('global.dataTelahDiSimpan'), false)
          history.push('/onpremise/tipePenghasilanLamp1771ivs')
        } catch(e) {
          callback(e, true, false)
        }
      }}
    />
  )
}

export default inject('envStore')(observer(TipePenghasilanLamp1771ivsForm))
